import React from 'react';
import { ToastContainer } from 'react-toastify';
import Routers from './Routes';
import dayjs from 'dayjs';
var localizedFormat = require("dayjs/plugin/localizedFormat");


dayjs.extend(localizedFormat);

function App() {
  return (
    <>
      <Routers />
      <ToastContainer />
    </>
  );
}

export default App;
